import { createContext } from 'react';
const LogExposureContext = /*#__PURE__*/createContext({
  logExposure: () => {}
});
export default LogExposureContext;